const _ = require('lodash');
const inViewContainerCtrl = require('./inViewContainerCtrl').default;

const deps = [];

const inViewContainerDirective = () => ({
  restrict: 'EAC',
  controller: inViewContainerCtrl,
  scope: false,
  link: (scope, elem, attrs, ctrl) => {
    ctrl.setElem(elem[0]);

    const fireCallbacks = () => ctrl.callbacks.forEach(cb => cb(elem[0]));
    const handler = () => {
      if (ctrl.windowHasFocus) {
        fireCallbacks();
      }
    };
    const throttledHandler = _.throttle(handler, 500);

    elem.on('scroll', throttledHandler);
    scope.$on('$destroy', () => elem.off('scroll'));
  },
});

const inViewChildDirective = () => ({
  restrict: 'EAC',
  require: '^blInViewContainer',
  scope: {
    onEnterView: '&',
    onLeaveView: '&',
  },
  link: (scope, elem, attrs, containerCtrl) => {
    const visibleInContainer = container => {
      const childRect = elem[0].getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      return containerRect.top <= childRect.top && containerRect.bottom >= childRect.bottom;
    };

    const visibilityChecker = container => {
      const visible = visibleInContainer(container);

      if (visible) {
        scope.onEnterView();
        return;
      }

      scope.onLeaveView();
    };

    const deregisterCallback = containerCtrl.registerCallback(visibilityChecker);
    scope.$on('$destroy', deregisterCallback);
  },
});

module.exports = angular
  .module('ui.web.inView', deps)
  .directive('blInViewContainer', inViewContainerDirective)
  .directive('blInViewChild', inViewChildDirective);
